import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.array-buffer.constructor";
import "core-js/modules/es.array-buffer.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.copy-within";
import "core-js/modules/es.typed-array.every";
import "core-js/modules/es.typed-array.fill";
import "core-js/modules/es.typed-array.filter";
import "core-js/modules/es.typed-array.find";
import "core-js/modules/es.typed-array.find-index";
import "core-js/modules/es.typed-array.for-each";
import "core-js/modules/es.typed-array.includes";
import "core-js/modules/es.typed-array.index-of";
import "core-js/modules/es.typed-array.iterator";
import "core-js/modules/es.typed-array.join";
import "core-js/modules/es.typed-array.last-index-of";
import "core-js/modules/es.typed-array.map";
import "core-js/modules/es.typed-array.reduce";
import "core-js/modules/es.typed-array.reduce-right";
import "core-js/modules/es.typed-array.reverse";
import "core-js/modules/es.typed-array.set";
import "core-js/modules/es.typed-array.slice";
import "core-js/modules/es.typed-array.some";
import "core-js/modules/es.typed-array.sort";
import "core-js/modules/es.typed-array.subarray";
import "core-js/modules/es.typed-array.to-locale-string";
import "core-js/modules/es.typed-array.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";

/* eslint-disable */
import { saveAs } from 'file-saver';
import XLSX2 from 'xlsx';
import XLSX from 'xlsx-style';

function generateArray(table) {
  var out = [];
  var rows = table.querySelectorAll('tr');
  var ranges = [];

  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.querySelectorAll('td');

    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var colspan = cell.getAttribute('colspan');
      var rowspan = cell.getAttribute('rowspan');
      var cellValue = cell.innerText;
      if (cellValue !== "" && cellValue === +cellValue) cellValue = +cellValue; //Skip ranges

      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) {
            outRow.push(null);
          }
        }
      }); //Handle Row Span

      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({
          s: {
            r: R,
            c: outRow.length
          },
          e: {
            r: R + rowspan - 1,
            c: outRow.length + colspan - 1
          }
        });
      }

      ; //Handle Value

      outRow.push(cellValue !== "" ? cellValue : null); //Handle Colspan

      if (colspan) for (var k = 0; k < colspan - 1; ++k) {
        outRow.push(null);
      }
    }

    out.push(outRow);
  }

  return [out, ranges];
}

;

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  };

  for (var R = 0; R !== data.length; ++R) {
    for (var C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C]
      };
      if (cell.v == null) continue;
      var cell_ref = XLSX2.utils.encode_cell({
        c: C,
        r: R
      });
      if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX2.SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = 's';
      ws[cell_ref] = cell;
    }
  }

  if (range.s.c < 10000000) ws['!ref'] = XLSX2.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);

  for (var i = 0; i != s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }

  return buf;
}

export function export_table_to_excel(tableArr, excelName) {
  /* generate workbook object from table */
  if (tableArr.length < 1) {
    _Message({
      message: '导出 sheet 为空',
      type: 'error',
      duration: 3 * 1000
    });

    return;
  }

  var wb = XLSX2.utils.book_new();
  tableArr.forEach(function (ele) {
    var fix = document.getElementById(ele.tableId).querySelector(".el-table__fixed");
    var ws;

    if (fix) {
      document.getElementById(ele.tableId).removeChild(fix);
      ws = XLSX2.utils.table_to_sheet(document.getElementById(ele.tableId), {
        raw: true
      });
      document.getElementById(ele.tableId).appendChild(fix);
    } else {
      ws = XLSX2.utils.table_to_sheet(document.getElementById(ele.tableId), {
        raw: true
      });
    } // 处理表头样式


    var range = XLSX2.utils.decode_range(ws["!ref"]);
    var borderStyle = {
      bottom: {
        style: 'thin',
        color: '000000'
      },
      left: {
        style: 'thin',
        color: '000000'
      },
      right: {
        style: 'thin',
        color: '000000'
      },
      top: {
        style: 'thin',
        color: '000000'
      }
    }; // console.log('range', range)

    var colsResult = [];

    for (var C = range.s.c; C <= range.e.c; ++C) {
      for (var R = range.s.r; R <= range.e.r; ++R) {
        var cell = {
          c: C,
          r: R
        };
        var cell_ref = XLSX2.utils.encode_cell(cell);

        if (ws["!merges"]) {
          ws["!merges"].forEach(function (item, mIndex) {
            if (item.e.r > range.e.r) {
              // 超过总行数
              ws["!merges"].splice(mIndex, 1);
              return;
            }

            if (item.e.r === item.s.r && item.e.c !== item.s.c) {
              // 列合并
              var _R = item.s.r;
              var countLen = item.e.c - item.s.c;

              for (var i = item.s.c; i <= item.e.c; i++) {
                var _cell = {
                  c: i,
                  r: _R
                };

                var _cell_ref = XLSX2.utils.encode_cell(_cell);

                if (!ws[_cell_ref]) {
                  ws[_cell_ref] = {
                    t: 's',
                    v: ""
                  };
                }
              }
            } else if (item.e.c === item.s.c && item.e.r !== item.s.r) {
              // 行合并
              var _C = item.s.c;

              var _countLen = item.e.r - item.s.r;

              for (var _i = item.s.r; _i <= item.e.r; _i++) {
                var _cell2 = {
                  c: _C,
                  r: _i
                };

                var _cell_ref2 = XLSX2.utils.encode_cell(_cell2);

                if (!ws[_cell_ref2]) {
                  ws[_cell_ref2] = {
                    t: 's',
                    v: ""
                  };
                }
              }
            }
          });
        }

        if (ws[cell_ref]) {
          // 列宽
          colsResult[cell.c] = {
            wch: ele.tableColsWidth ? ele.tableColsWidth : 15
          };
          var cellStyle = {
            alignment: {
              horizontal: "center",
              // 水平对齐-居中
              vertical: "center",
              // 垂直对齐-居中
              wrap_text: true
            },
            border: borderStyle
          };

          if (cell.r === 0 || ele.tableRows !== undefined && ele.tableRows > 0 && cell.r < ele.tableRows) {
            // 表头
            cellStyle.font = {
              sz: 13,
              bold: true,
              italic: false,
              underline: false
            };
            cellStyle.fill = {
              fgColor: {
                rgb: 'EBF1DE'
              }
            };
          }

          ws[cell_ref].s = cellStyle;
        }
      }
    }
    /*设置worksheet每列的最大宽度*/


    ws['!cols'] = colsResult; // ws['!protect'] = {selectLockedCells: true, selectUnLockCells: true, password: '210419'}

    XLSX2.utils.book_append_sheet(wb, ws, ele.name);
  });
  /* get binary string as output */

  var wbOut = XLSX.write(wb, {
    bookType: 'xlsx',
    cellStyles: true,
    bookSST: false,
    type: 'binary',
    showGridLines: false
  });

  try {
    saveAs(new Blob([s2ab(wbOut)], {
      type: "application/octet-stream"
    }), excelName + ".xlsx");
  } catch (e) {
    if (typeof console !== 'undefined') {
      _Message({
        message: '导出报表异常',
        type: 'error',
        duration: 3 * 1000
      }); // console.log(e, wbOut)

    }
  }
}
export function export_json_to_excel() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$multiHeader = _ref.multiHeader,
      multiHeader = _ref$multiHeader === void 0 ? [] : _ref$multiHeader,
      header = _ref.header,
      data = _ref.data,
      filename = _ref.filename,
      _ref$merges = _ref.merges,
      merges = _ref$merges === void 0 ? [] : _ref$merges,
      _ref$autoWidth = _ref.autoWidth,
      autoWidth = _ref$autoWidth === void 0 ? true : _ref$autoWidth,
      _ref$bookType = _ref.bookType,
      bookType = _ref$bookType === void 0 ? 'xlsx' : _ref$bookType;

  /* original data */
  filename = filename || 'excel-list';
  data = _toConsumableArray(data);
  data.unshift(header);

  for (var i = multiHeader.length - 1; i > -1; i--) {
    data.unshift(multiHeader[i]);
  }

  var ws_name = "SheetJS";
  var wb = new Workbook(),
      ws = sheet_from_array_of_arrays(data);

  for (var key in ws) {
    if (new RegExp('^[A-Za-z0-9]+$').exec(key)) {
      var wCell = key.toString();
      var headerBold = false;
      var fontSize = 12;
      var fontColor = {
        rgb: '000000'
      };
      var cellFill = {
        fgColor: {
          rgb: 'FFFFFF'
        }
      };

      if (new RegExp('^[A-Z]+1$').exec(key)) {
        headerBold = true;
        fontSize = 13;
        fontColor = {
          rgb: '000000'
        };
        cellFill = {
          fgColor: {
            rgb: 'EBF1DE'
          }
        };
      }

      ws[wCell].s = {
        fill: cellFill,
        border: {
          bottom: {
            style: 'thin',
            color: '000000'
          },
          left: {
            style: 'thin',
            color: '000000'
          },
          right: {
            style: 'thin',
            color: '000000'
          },
          top: {
            style: 'thin',
            color: '000000'
          }
        },
        alignment: {
          horizontal: "center",
          // 水平对齐-居中
          vertical: "center",
          // 垂直对齐-居中
          wrap_text: true
        },
        font: {
          sz: fontSize,
          color: fontColor,
          bold: headerBold,
          italic: false,
          underline: false
        }
      };
    }
  }

  if (merges.length > 0) {
    if (!ws['!merges']) ws['!merges'] = [];
    merges.forEach(function (item) {
      ws['!merges'].push(XLSX2.utils.decode_range(item));
    });
  }

  if (autoWidth) {
    /*设置worksheet每列的最大宽度*/
    var colWidth = data.map(function (row) {
      return row.map(function (val) {
        /*先判断是否为null/undefined*/
        if (val == null) {
          return {
            'wch': 10
          };
        }
        /*再判断是否为中文*/
        else if (val.toString().charCodeAt(0) > 255) {
            return {
              'wch': val.toString().length * 2
            };
          } else {
            return {
              'wch': val.toString().length
            };
          }
      });
    });
    /*以第一行为初始值*/

    var result = colWidth[0];

    for (var _i2 = 1; _i2 < colWidth.length; _i2++) {
      for (var j = 0; j < colWidth[_i2].length; j++) {
        if (result[j]['wch'] < colWidth[_i2][j]['wch']) {
          result[j]['wch'] = colWidth[_i2][j]['wch'];
        }
      }
    }

    ws['!cols'] = result;
  }
  /* add worksheet to workbook */


  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;
  var wbout = XLSX.write(wb, {
    bookType: bookType,
    cellStyles: true,
    bookSST: false,
    type: 'binary',
    showGridLines: false
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), "".concat(filename, ".").concat(bookType));
}